import React from 'react';
import { type UseFormRegisterReturn } from 'react-hook-form';

import { Input } from '@/components/ui/input';
import { FormField } from '@/shared/ui/form-field';
import { cn } from '@/lib/utils';

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  registration?: UseFormRegisterReturn;
  required?: boolean;
}

export const FormInput = React.forwardRef<HTMLInputElement, FormInputProps>(
  ({ label, error, registration, className, id, required, ...props }, ref) => {
    const fieldName = id || registration?.name || 'field';

    return (
      <FormField label={label} name={fieldName} error={error} required={required}>
        <Input
          ref={ref}
          id={fieldName}
          className={cn(className, {
            'bg-muted text-muted-foreground pointer-events-none': props.readOnly
          })}
          tabIndex={props.readOnly ? -1 : props.tabIndex}
          {...registration}
          {...props}
        />
      </FormField>
    );
  }
);

FormInput.displayName = 'FormInput';
